// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const LineChartIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="LineChartIcon" ref={forwardedRef} {...props}>
      <path d="M4.483 3h-1.5v13a1 1 0 0 0 1 1h13v-1.5h-12.5v-1.984l.021.022 3.681-3.562 3.458 2.51 5.374-5.46-1.069-1.052-4.469 4.54-3.432-2.491-3.564 3.449z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const LineChartIcon = /* @__PURE__ */ Object.assign(
  LineChartIconComponent,
  { displayName: 'LineChartIcon' },
);
